import { useTranslation } from 'react-i18next';
import { getUiLanguage } from '@/shared/config';
import { isUiLanguage, type UiLanguage } from '@/shared/lib';
import { SegmentedControl } from '@/shared/ui';
import { useChangeLanguage } from '../model/useChangeLanguage';

export interface LanguageSwitcherProps {
  /** Языки интерфейса рынка (GET /admin/config `languages`). */
  languages: readonly UiLanguage[];
}

/**
 * Плавающий переключатель языка World (README §1): справа внизу, «EN» / «ES».
 * Показывается, только если языков больше одного.
 */
export function LanguageSwitcher({ languages }: LanguageSwitcherProps) {
  const { t, i18n } = useTranslation('shell');
  const changeLanguage = useChangeLanguage();
  if (languages.length < 2) return null;
  const current = isUiLanguage(i18n.language) ? i18n.language : getUiLanguage();
  return (
    <div className="fixed right-16 bottom-16 z-90">
      <SegmentedControl
        variant="floating"
        aria-label={t('language.label')}
        value={current}
        onValueChange={(value) => {
          if (isUiLanguage(value)) void changeLanguage(value);
        }}
        items={languages.map((language) => ({
          value: language,
          label: t(`language.short.${language}`),
        }))}
      />
    </div>
  );
}
